interface Medias {
  mediaType: string | null;
  fullImage: string | null;
}

export function itemMedia(mediasArray: Medias[], mediaType: string): string[];
export function itemMedia(mediasArray: Medias[], mediaType: string[]): string[];

export function itemMedia(medias, mediaType) {
  if (typeof mediaType === 'string') {
    return medias.reduce((acc: string[], cur) => {
      if (cur.mediaType.toLowerCase().startsWith(mediaType)) {
        return [...acc, cur.fullImage];
      }

      return acc;
    }, []);
  }
  return mediaType.reduce((acc: string[], mediaTypeString) => {
    const imageUrl = medias.find(media =>
      media.mediaType.toLowerCase().startsWith(mediaTypeString.toLowerCase()),
    );
    if (imageUrl) {
      return [...acc, imageUrl.fullImage];
    }
    return acc;
  }, []);
}
